import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import PageTracker from '../../../common/PageTrackerHelper'
import moment from 'moment'
import Printd from 'printd'
import { getOnePagerEnabledFlag } from "../../../../services/modules/printlabelservices.js";
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";
import dummyInput from '../common/smartInput.vue'

export default {
  name: 'PrintLabel',
  components: {
    VueElementLoading,
    Treeselect,
    'dummy-input': dummyInput
  },
  mixins:[PageTracker],
  data: function() {
    return {
      shippingID: '',
      username: '',
      hubId: '',
      localuserid : '',
      isLoading: false,
      shipmentDetails:[],
      requestParam:{},
      selected:'',
      shipment:'',
      responseData:'',
      validationerror:'',
    //  centertype:'',
      shipmentData:[],
      prnData:'',
      IsDtoRestrict: false,
      IsRtoRestrict: false,
      memcacheFlag: false,
      userDataKey : '',
      isSelectPrinter:'0',
      isRedirectLoading: false,
      redirectionMsg: 'Redirecting, please wait...',
      isManualEntryRestrict: false,
      ttl: 100,
      keyFiredCount: { 'value': 0 },
      flyerBarcodeList: [],
      lastKeyTime: 0,
      isScannerInput: null,
      threshold: 50, // Fast keystroke threshold
      scanTimeout: null,
      isShowDummyInput: false,
      styleData: {},
      dummyInputTimeout: 20000,
      shipmentValue: ''
    }
  },
  filters: {
    dateFormat: function(date) {
      if (date == null || date == '')
        return '-'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  created: function() {},
  watch: {
    shipment: createClearInputWatcher('shipment'),
    shippingID: createClearInputWatcher('shippingID'),
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.username = userdetail.username;
    this.localuserid =  userdetail.userid
    this.hubId = userdetail.hubdetails[0]
    this.memcacheFlag = await this.checkMemcacheFlag()
    console.log("memcacheFlag",this.memcacheFlag);
    if(!this.memcacheFlag){
      this.checkStickerRestriction();
    }
    this.checkOnePagerEnabled();
    // let TrackerInfo = {
    //     projectname:"Last Mile",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.username,
    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
  },
  methods: {
    submitform() {
      // if(this.centertype == 'hub'){
      //   this.showRTOLabel2();
      // }else {
        this.isShowDummyInput = false;
        this.shipmentValue = this.selected == '0' ? this.shippingID : this.shipment;
        if(this.selected == '0'){
          this.showdata();
        }
        if(this.selected == '1') {
          this.showRTOLabel2();
        }
      //}
    },

    checkMemcacheFlag(){
      return new Promise((resolve, reject) => {
        try{
          let payload = {
            "key" : "RtoDtoStickerRestrictionFlag"
          }
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'memcache/get',
            data: payload,
          })
          .then(async result => {
            if(result.data.code == 200){
              if(result.data.message == "true"){
                resolve(true);
              }
              else{
                resolve(false);
              }
            }
            else{
              resolve(false);
            }
          })    
        }
        catch(e){
          resolve(false);
        }
      })
    },
    
    checkStickerRestriction(){
      let payload = {
        "HubId" : this.hubId
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'external/get/sticker/restriction/flag',
        data: payload,
      })
      .then(async result => {
        if(result.data.code == 200){
          this.IsDtoRestrict = result.data.data[0].isdtorestrictprinting;
          this.IsRtoRestrict = result.data.data[0].isrtorestrictprinting;
          if (!result.data.data[0].flyerBarcodeList) {
            this.flyerBarcodeList = [];
          }else{
          this.flyerBarcodeList = result.data.data[0].flyerBarcodeList
          }
          this.flyerBarcodeList.push("2");
        }
        else{
          this.IsDtoRestrict = false;
          this.IsRtoRestrict = false;
        }
        this.ttl = result && result.data && result.data.restrictionRes.ttl ? result.data.restrictionRes.ttl : 200;
        this.isManualEntryRestrict = result && result.data && result.data.restrictionRes.isRestriction ? result.data.restrictionRes.isRestriction : false;
        console.log("isdtorestrictprinting",this.IsDtoRestrict);
        console.log("isrtorestrictprinting",this.IsRtoRestrict);
        console.log("isManualEntryRestrict::::::", this.isManualEntryRestrict + "TTL:::::::",this.ttl);
        if(this.IsDtoRestrict == false){
          this.selected = '0'
        }
        else{
          this.selected = '1'
        }
      })
    },

    showShipmentLabel(requestParam) {
      requestParam.hubid = parseInt(this.hubId);
      this.isLoading = true;
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/web/get/DataForDTOSlip',
        data: requestParam,
        responseType: 'blob'
      })
      .then(async result => {
        // Start the spinner loader for redirection.
        this.isRedirectLoading = true;
      
        // Delay of 2 seconds before redirecting
        // setTimeout(() => {
          // Perform the redirection
          this.$router.push('/InScanRVPShipments');
          // Stop the loader after the redirection
          this.isRedirectLoading = false;
      
          // Execute this after the redirection
          if (result.data.type == 'application/pdf') {
            const downloadUrl = window.URL.createObjectURL(new Blob([result.data], { type: 'application/pdf' }));
    
            let message = {
              title: '',
              body: `<p>Pdf is generated, Would you like to open.!</p>`,
            };
    
            this.$dialog.alert(message, {
              html: true,
              animation: 'bounce',
              backdropClose: false,
              loader: true,
              loaderMsg: 'Loading PDF, please wait...'
            })
            .then(dialog => {
              window.open(downloadUrl);
              this.reset();
              dialog.close();
            })
            .catch(() => {
              this.isRedirectLoading = false;
            });
          }
        // }, 2000); // 2-second delay
      })  
      .catch(() => {
        this.isLoading = false;
        console.log('errors exist', this.errors)
      });
    },
    reset() {
      this.$validator.reset();
      this.shippingID = '';
      this.isLoading = false;
      this.requestParam = {};
      this.shipmentDetails = [];
      this.shipment = '';
      this.validationerror = '';
      this.isShowDummyInput = false;
      this.$refs.dummyShipInputBox.clearStyles();
      if(this.memcacheFlag){
        this.selected = '';
      }
    },
    showdata(){
      if(this.shippingID == ''){
        this.validationerror = 'Please enter valid flyer barcode';
      }else {
      this.shipmentDetails = [];
      this.input = {
        "FlyerBarcodeNumber": this.shippingID.trim().toUpperCase(),
        "requestedBy":this.username
    //     "IsShippingId":false
      }
      if(this.shippingID.trim().toUpperCase().startsWith('RVP')){
        this.input.IsShippingId = false;
      }else {
        this.input.IsShippingId = true;
      }
      this.isLoading = true;
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/web/get/flyerBarcode/details',
        data: this.input
      })
      .then(async result => {
        this.isShowDummyInput = true;
        this.styleData = result.data.lossCategorization;

        if(result.data.code == 200){
        this.shipmentDetails = result.data.data;
        if(this.shipmentDetails.length == 1){
          this.requestParam = {
            "FlyerBarcodeNumber": this.shippingID.trim().toUpperCase(),
             "IsShippingId":false
          }
          this.showShipmentLabel(this.requestParam);
        }else {
          this.isLoading = false;
        }
      }
      else {
        this.reset();
        this.$alertify.error(result.data.message);
      }
      })
    }
    },
    printDTOslip(AWBNumber){
      this.requestParam ={
        "FlyerBarcodeNumber": AWBNumber,
         "IsShippingId":true
      }
      this.showShipmentLabel(this.requestParam);
    },
    setUppercase(){
      this.shippingID = this.shippingID.toUpperCase();
    },
    showRTOLabel(){
      if(this.shipment == ''){
        this.validationerror = 'Please enter valid AWB barcode';
      }else {
      this.validationerror = '';
      this.shipmentDetails = [];
      this.input = {
        "shippingid": this.shipment.trim(),
      }
      this.isLoading = true;
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'external/RTO/sticker/print/format',
        data: this.input
      })
      .then(async result => {
	       console.log("result",result);
        if(result.data.code == 200 ) {
          let baseresult = result.data.base64 ;
          const byteCharacters = atob(baseresult);
      	  const byteNumbers = new Array(byteCharacters.length);
      	  for (let i = 0; i < byteCharacters.length; i++) {
      	     byteNumbers[i] = byteCharacters.charCodeAt(i);
      	  }
      	  const byteArray = new Uint8Array(byteNumbers);
      	  let contentType = 'application/pdf';
      	  const blob = new Blob([byteArray], {type: contentType});
      	  const blobUrl = URL.createObjectURL(blob);
          const d = new Printd()
          let message = {
           title: '',
            body: `<p>Pdf is generated, Would you like to open.!</p>`,
          };

         let res = this.$dialog.alert(message, {
             html: true,
             animation: 'bounce',
             backdropClose: false,
             loader: true
          }).then(dialog => {
            d.printURL(blobUrl, ({ launchPrint }) => {
              // fire printing!
              launchPrint()
              this.reset();
             dialog.close();
             }).catch(() => {
                this.isLoading = false
          })
          }).catch(() => {
             this.isLoading = false
           });
        } else {
          this.reset();
           this.$alertify.error(result.data.message);
           }
       }).catch(() => {
          this.isLoading = false;
           console.log('errors exist', this.errors)
       });
     }
   },
   showRTOLabel2(){
     if(this.shipment == ''){
       this.validationerror = 'Please enter valid AWB barcode';
     }else {
     this.validationerror = '';
     this.shipmentDetails = [];
     if(this.shipment.toUpperCase().startsWith('RVP')){
       this.input = {
         "fliercode": this.shipment.trim(),
         "requestedBy":this.username
       }
     }else{
       this.input = {
         "shippingid": this.shipment.trim(),
         "requestedBy":this.username
       }
     }
     this.input.CurrentHubID = this.hubId
     this.isLoading = true;
     axios({
       method: 'POST',
       url: apiUrl.api_url + 'external/RTO/sticker/print/data',
       data: this.input
     })
     .then(async result => {
        console.log("result",result);
       if(result.data.code == 200 ) {
         this.shipmentData=result.data.data;
         this.isShowDummyInput = true;
         this.styleData = result.data.lossCategorization;
 
						if(this.shipmentData.shipmenttype && this.shipmentData.shipmenttype.toLowerCase()=='dto'){
              if (this.isSelectPrinter  == '1') {
                console.log("---DTO New---");
                
                this.prnData = `^XA
                    ^SZ2^JMA
                    ^MCY^PMN
                    ^PW812
                    ~SD12^MD0^MTD
                    ~JSN
                    ^JZY
                    ^LH0,0^LRN
                    ^XZ
                    ^XA
                    ^FO3,73
                    ^GB803,0,3^FS
                    ^FO3,134
                    ^GB803,0,3^FS
                    ^FO3,240
                    ^GB803,0,3^FS
                    ^FO3,328
                    ^GB803,0,3^FS
                    ^FO3,423
                    ^GB803,0,3^FS
                    ^FO3,516
                    ^GB803,0,3^FS
                    ^FO332,75
                    ^GB0,61,3^FS
                    ^FO482,77
                    ^GB0,250,3^FS
                    ^FO560,77
                    ^GB0,250,3^FS
                    ^FO710,76
                    ^GB0,61,3^FS
                    ^FO149,241
                    ^GB0,350,3^FS
                    ^FO393,425
                    ^GB0,91,3^FS
                    ^FO504,426
                    ^GB0,91,3^FS
                    ^FO301,520
                    ^GB0,65,3^FS
                    ^FT33,43
                    ^CI0
                    ^A0N,38,30^FDXPRESSBEES^FS
                    ^FT115,65
                    ^A0N,17,23^FDDelivering Happiness^FS
                    ^FT401,51
                    ^A0N,39,26^FD${this.shipmentData.dummyRouteCodeData}^FS
                    ^FT730,48
                    ^A0N,39,26^FD${this.shipmentData.shipmenttype}^FS
                    ^FT31,114
                    ^A0N,42,30^FDRemarks :-^FS
                    ^FT176,116
                    ^A0N,42,30^FD${this.shipmentData.remarks}^FS
                    ^FT341,114
                    ^A0N,42,30^FD${this.shipmentData.rtogcregion + this.shipmentData.rtogctype}^FS
                    ^FT510,114
                    ^A0N,42,30^FD${this.shipmentData.destination}^FS
                    ^FT587,114
                    ^A0N,42,30^FD${this.shipmentData.routenumber}^FS
                    ^FT730,114
                    ^A0N,42,30^FD${this.shipmentData.routecode}^FS
                    ^FT489,170
                    ^A0N,31,16^FDFlier Code^FS
                    ^FT490,211
                    ^A0N,23,28^FD${this.shipmentData.truncfliercode}^FS
                    ^FT571,170
                    ^A0N,28,19^FDLast WH Handover Date^FS
                    ^FT570,211
                    ^A0N,23,28^FD${this.shipmentData.lastwhhandoverdateformated}^FS
                    ^FO18,148
                    ^BY2^BCN,50,N,N^FD>:${this.shipmentData.shippingid}^FS
                    ^FT140,225
                    ^A0N,25,27^FD${this.shipmentData.shippingid}^FS
                    ^FT489,295
                    ^A0N,34,18^FDEway Bill^FS
                    ^FT589,296
                    ^A0N,34,28^FD${this.shipmentData.ewaybill}^FS
                    ^FT22,277
                    ^A0N,34,23^FDVendor^FS
                    ^FT22,311
                    ^A0N,34,23^FDName :-^FS
                    ^FT157,271
                    ^A0N,25,20^FD${this.shipmentData.vendorname1}^FS
                    ^FT157,297
                    ^A0N,25,20^FD${this.shipmentData.vendorname2}^FS
                    ^FT157,323
                    ^A0N,25,20^FD${this.shipmentData.vendorname3}^FS
                    ^FT23,370
                    ^A0N,34,23^FDVendor^FS
                    ^FT23,405
                    ^A0N,34,23^FDAddress :-^FS
                    ^FT158,355
                    ^A0N,17,25^FD${this.shipmentData.vendoraddress1}^FS
                    ^FT158,375
                    ^A0N,17,25^FD${this.shipmentData.vendoraddress2}^FS
                    ^FT158,395
                    ^A0N,17,25^FD${this.shipmentData.vendoraddress3}^FS
                    ^FT158,415
                    ^A0N,17,25^FD${this.shipmentData.vendoraddress4}^FS
                    ^FT23,465
                    ^A0N,34,23^FDDestination^FS
                    ^FT23,500
                    ^A0N,34,23^FDHub :-^FS
                    ^FT160,455
                    ^A0N,28,25^FD${this.shipmentData.destinationhub1}^FS
                    ^FT160,480
                    ^A0N,28,25^FD${this.shipmentData.destinationhub2}^FS
                    ^FT160,505
                    ^A0N,28,25^FD${this.shipmentData.destinationhub3}^FS
                    ^FT408,465
                    ^A0N,34,22^FDClient^FS
                    ^FT408,498
                    ^A0N,34,22^FDName :-^FS
                    ^FT513,450
                    ^A0N,25,25^FD${this.shipmentData.clientname1}^FS
                    ^FT513,476
                    ^A0N,25,25^FD${this.shipmentData.clientname2}^FS
                    ^FT513,500
                    ^A0N,25,25^FD${this.shipmentData.clientname3}^FS
                    ^FT15,545
                    ^A0N,25,25^FDDelivery^FS
                    ^FT15,570
                    ^A0N,25,25^FDPincode :-^FS
                    ^FT170,554
                    ^A0N,28,38^FD${this.shipmentData.deliverypincode}^FS
                    ^FT320,548
                    ^A0N,23,16^FDPO ID /^FS
                    ^FT320,570
                    ^A0N,23,16^FDOrderId :-^FS
                    ^FO400,530
                    ^BCN,27,N,N^FD>:${this.shipmentData.poid}^FS
                    ^FT472,580
                    ^A0N,23,23^FD${this.shipmentData.poid}^FS
                    ^PQ1,0,1,Y
                    ^XZ`;
                
              } else {
                console.log("---DTO Old---");
                this.prnData = 'n\n' + 'M0751\n' + 'KW0400\n' + 'O0220\n' + 'V0\n' + 'f303\n' + 'D\n' + 'L\n' + 'D11\n' + 'A2\n' + '1X1100002690000L400001\n' + '1921A0602850007XPRESSBEES\n' +
                  '1911A1402740338' + this.shipmentData.shipmenttype + '\n' +
                  '1X1100002420000L400001\n' +
                  '1911A1202470162' + this.shipmentData.rtogcregion +'/'+ this.shipmentData.rtogctype + '\n' +
                  '1911A1202470253' + this.shipmentData.destination + '\n' +
                  '1911A1202470308' + this.shipmentData.routenumber + '\n' +
                  '1911A1202470347' + this.shipmentData.routecode + '\n' +
                  '1911A0602740082Delivering Happiness\n' +
                  '1X1100002420144L001027\n' + '1X1100002420244L001027\n' + '1X1100002410289L001028\n' + '1X1100002420344L001027\n' +
                  '1X1100001670000L400001\n' + '1X1100001290000L400001\n' + '1X1100000810000L400001\n' + '1X1100000420000L400001\n' + '1911A0801480007Vendor\n' +
                  '1911A0801360007Name :- \n' + '1911A0801040007Vendor\n' + '1911A0800930007Address :-\n' + '1911A0800590007Destination\n' + '1911A0800470007Hub :-\n' +
                  '1911A0800610197Client\n' + '1911A0800490197Name :-\n' + '1911A0602190298Last WH Handover Date\n' +
                  '1911A1201840303' + this.shipmentData.lastwhhandoverdateformated + '\n' +
                  '1X1100001670289L001076\n' +
                  '1911A0600660253' + this.shipmentData.clientname1 + '\n' +
                  '1911A0600570253' + this.shipmentData.clientname2 + '\n' +
                  '1911A0600480253' + this.shipmentData.clientname3 + '\n' +
                  '1911A0601140074' + this.shipmentData.vendoraddress1 + '\n' +
                  '1911A0601050074' + this.shipmentData.vendoraddress2 + '\n' +
                  '1911A0600960074' + this.shipmentData.vendoraddress3 + '\n' +
                  '1911A0600870074' + this.shipmentData.vendoraddress4 + '\n' +
                  '1911A0601530073' + this.shipmentData.vendorname1 + '\n' +
                  '1911A0601440073' + this.shipmentData.vendorname2 + '\n' +
                  '1911A0601350073' + this.shipmentData.vendorname3 + '\n' +
                  '1911A0600660080' + this.shipmentData.destinationhub1 + '\n' +
                  '1911A0600570080' + this.shipmentData.destinationhub2 + '\n' +
                  '1911A0600480080' + this.shipmentData.destinationhub3 + '\n' +
                  '1911A0800180007Delivery Pincode :-\n' + '1X1100000010102L001041\n' +
                  '1911A0802500007Remarks :- ' + this.shipmentData.remarks + '\n' +
                  '1X1100000430069L001125\n' + '1X1100000430193L001038\n' + '1X1100000420244L001039\n' + '1X1100003000000L400001\n' +
                  '1911A1202740183' + this.shipmentData.dummyRouteCodeData + '\n' +
                  '1e6205201840010B' + this.shipmentData.shippingid + '\n' +
                  '1911A0801700066' + this.shipmentData.shippingid + '\n' +
                  '1X1100001680228L001075\n' + '1911A0602190240Flier Code\n' +
                  '1911A1201840242' + this.shipmentData.truncfliercode + '\n' +
                  '1a3101800190210' + this.shipmentData.poid + '\n' +
                  '1911A0600070245' + this.shipmentData.poid + '\n' +
                  '1911A0600200107' + this.shipmentData.deliverypincode + '\n' +
                  '1X1100000010137L001042\n' + '1911A0600200145POID/ Order ID\n' +
                  '1911A0801420308' + this.shipmentData.ewaybill + '\n' +
                  '1X1100001300300L001038\n' + '1911A0801420246E-way Bill\n' + '1X1100001300241L001038\n' +
                  'Q0001\n' +
                  'E\n';
              } 
          }
          else if(this.IsRtoRestrict){

              if (this.isSelectPrinter  == '1') {
                console.log("---RTO New---");
                this.prnData = `^XA
                  ^SZ2^JMA
                  ^MCY^PMN
                  ^PW812
                  ~SD12^MD0^MTD
                  ~JSN
                  ~SD25^MD0
                  ^JZY
                  ^LH0,0^LRN
                  ^XZ
                  ^XA
                  ^FO3,73
                  ^GB803,0,3^FS
                  ^FO2,142
                  ^GB805,0,3^FS
                  ^FO3,248
                  ^GB803,0,3^FS
                  ^FO3,336
                  ^GB803,0,3^FS
                  ^FO8,432
                  ^GB803,0,3^FS
                  ^FO8,524
                  ^GB803,0,3^FS
                  ^FO309,75
                  ^GB0,66,3^FS
                  ^FO466,75
                  ^GB0,66,3^FS
                  ^FO560,75
                  ^GB0,66,3^FS
                  ^FO710,75
                  ^GB0,66,3^FS
                  ^FO560,146
                  ^GB0,101,3^FS
                  ^FO149,249
                  ^GB0,91,3^FS
                  ^FO149,340
                  ^GB0,91,3^FS
                  ^FO148,434
                  ^GB0,91,3^FS
                  ^FO393,435
                  ^GB0,91,3^FS
                  ^FO504,434
                  ^GB0,91,3^FS
                  ^FO215,524
                  ^GB0,60,3^FS
                  ^FO361,524
                  ^GB0,60,3^FS
                  ^FO504,524
                  ^GB0,60,3^FS
                  ^FT33,43
                  ^CI0
                  ^A0N,38,30^FDXPRESSBEES^FS
                  ^FT115,65
                  ^A0N,17,23^FDDelivering Happiness^FS
                  ^FT382,63
                  ^A0N,45,30^FD${this.shipmentData.dummyRouteCodeData}^FS
                  ^FT712,54
                  ^A0N,45,30^FD${this.shipmentData.shipmenttype}^FS
                  ^FT21,118
                  ^A0N,42,30^FDDelivery Type : ${this.shipmentData.deliverytype}^FS
                  ^FT318,118
                  ^A0N,42,30^FD${this.shipmentData.rtogcregion + this.shipmentData.rtogctype}^FS
                  ^FT487,118
                  ^A0N,42,30^FD${this.shipmentData.destination}^FS
                  ^FT592,118
                  ^A0N,42,30^FD${this.shipmentData.routenumber}^FS
                  ^FT730,118
                  ^A0N,42,30^FD${this.shipmentData.routecode}^FS
                  ^FO50,149
                  ^BY2^BCN,53,N,N^FD>:${this.shipmentData.shippingid}^FS
                  ^FT50,229
                  ^A0N,25,27^FD${this.shipmentData.shippingid}^FS
                  ^FT571,178
                  ^A0N,28,20^FDLast WH Handover Date^FS
                  ^FT571,224
                  ^A0N,30,30^FD${this.shipmentData.lastwhhandoverdateformated}^FS
                  ^FT20,285
                  ^A0N,34,23^FDVendor^FS
                  ^FT20,320
                  ^A0N,34,23^FDName :-^FS
                  ^FT160,280
                  ^A0N,20,20^FD${this.shipmentData.vendorname1}^FS
                  ^FT160,317
                  ^A0N,20,20^FD${this.shipmentData.vendorname2}^FS
                  ^FT20,378
                  ^A0N,34,23^FDVendor^FS
                  ^FT20,413
                  ^A0N,34,23^FDAddress :-^FS
                  ^FT158,356
                  ^A0N,17,25^FD${this.shipmentData.vendoraddress1}^FS
                  ^FT158,377
                  ^A0N,17,25^FD${this.shipmentData.vendoraddress2}^FS
                  ^FT158,398
                  ^A0N,17,25^FD${this.shipmentData.vendoraddress3}^FS
                  ^FT158,419
                  ^A0N,17,25^FD${this.shipmentData.vendoraddress4}^FS
                  ^FT20,473
                  ^A0N,34,23^FDDestination^FS
                  ^FT20,508
                  ^A0N,34,23^FDHub :-^FS
                  ^FT158,461
                  ^A0N,28,25^FD${this.shipmentData.destinationhub1}^FS
                  ^FT158,487
                  ^A0N,28,25^FD${this.shipmentData.destinationhub2}^FS
                  ^FT158,514
                  ^A0N,28,25^FD${this.shipmentData.destinationhub3}^FS
                  ^FT410,473
                  ^A0N,34,23^FDClient^FS
                  ^FT410,503
                  ^A0N,34,23^FDName :-^FS
                  ^FT517,461
                  ^A0N,25,25^FD${this.shipmentData.clientname1}^FS
                  ^FT517,491
                  ^A0N,25,25^FD${this.shipmentData.clientname2}^FS
                  ^FT517,521
                  ^A0N,25,25^FD${this.shipmentData.clientname3}^FS
                  ^FT20,566
                  ^A0N,34,23^FDDelivery Pincode :-^FS
                  ^FT228,564
                  ^A0N,28,38^FD${this.shipmentData.deliverypincode}^FS
                  ^FT380,564
                  ^A0N,28,19^FDE-WAY Bill :-^FS
                  ^FT549,562
                  ^A0N,28,38^FD${this.shipmentData.ewaybill}^FS
                  ^PQ1,0,1,Y
                  ^XZ`;

              } else {
                console.log("---RTO Old---");
                this.prnData = 'n\n' + 'M0751\n' + 'KW0400\n' + 'O0220\n' + 'V0\n' + 'f303\n' + 'D\n' + 'L\n' + 'D11\n' + 'A2\n' + '1X1100002690000L400001\n' + '1921A0602850007XPRESSBEES\n' +
                  '1911A1402740337' + this.shipmentData.shipmenttype + '\n' +
                  '1X1100002420000L400001\n' +
                  '1911A1202470162' + this.shipmentData.rtogcregion +'/'+ this.shipmentData.rtogctype + '\n' +
                  '1911A1202470253' + this.shipmentData.destination + '\n' +
                  '1911A1202470308' + this.shipmentData.routenumber + '\n' +
                  '1911A1202470353' + this.shipmentData.routecode + '\n' +
                  '1911A0602740082Delivering Happiness\n' +
                  '1X1100002420144L001027\n' + '1X1100002420244L001027\n' + '1X1100002420289L001027\n' + '1X1100002420344L001027\n' + '1X1100001670000L400001\n' + '1X1100001290000L400001\n' +
                  '1X1100000810000L400001\n' + '1X1100000420000L400001\n' +
                  '1e6205201840010B' + this.shipmentData.shippingid + '\n' +
                  '1911A1001670042' + this.shipmentData.shippingid + '\n' +
                  '1911A0801480007Vendor\n' + '1911A0801360007Name :- \n' + '1911A0801040007Vendor\n' + '1911A0800930007Address :-\n' + '1911A0800590007Destination\n' +
                  '1911A0800470007Hub :-\n' + '1911A0800610197Client\n' + '1911A0800490197Name :-\n' + '1911A0602190290Last WH Handover Date\n' +
                  '1911A1201840289' + this.shipmentData.lastwhhandoverdateformated + '\n' +
                  '1X1100001680265L001075\n' +
                  '1911A0600660253' + this.shipmentData.clientname1 + '\n' +
                  '1911A0600570253' + this.shipmentData.clientname2 + '\n' +
                  '1911A0600480253' + this.shipmentData.clientname3 + '\n' +
                  '1911A0601140080' + this.shipmentData.vendoraddress1 + '\n' +
                  '1911A0601050080' + this.shipmentData.vendoraddress2 + '\n' +
                  '1911A0600960080' + this.shipmentData.vendoraddress3 + '\n' +
                  '1911A0600870080' + this.shipmentData.vendoraddress4 + '\n' +
                  '1911A0601480078' + this.shipmentData.vendorname1 + '\n' +
                  '1911A0601390078' + this.shipmentData.vendorname2 + '\n' +
                  '1911A0600660080' + this.shipmentData.destinationhub1 + '\n' +
                  '1911A0600570080' + this.shipmentData.destinationhub2 + '\n' +
                  '1911A0600480080' + this.shipmentData.destinationhub3 + '\n' +
                  '1911A0800170007Delivery Pincode :-\n' + '1X1100000010129L001041\n' +
                  '1911A0800170133' + this.shipmentData.deliverypincode + '\n' +
                  '1X1100000420194L001039\n' + '1X1100000010194L001042\n' + '1911A0800160197E-way Bill\n' + '1X1100000010274L001042\n' +
                  '1911A0800170285' + this.shipmentData.ewaybill + '\n' +
                  '1911A0802500007Delivery Type :- ' + this.shipmentData.deliverytype + '\n' +
                  '1X1100000430069L001125\n' + '1X1100000420244L001039\n' + '1X1100003000000L400001\n' +
                  '1911A1202740183' + this.shipmentData.dummyRouteCodeData + '\n' + 'Q0001\n' + 'E\n';
              }
            }
            else{
              this.$alertify.error("Shipment not eligible for Printing");
              this.isLoading = false;
            }
            //  console.log("prn"+JSON.stringify(this.prnData));
             if(this.prnData){
               this.printsticker()
             }
				//		this.$alertify.success(result.data.message);

       } else {
         this.reset();
          this.$alertify.error(result.data.message);
          }
      }).catch(() => {
         this.isLoading = false;
          console.log('errors exist', this.errors)
      });
    }
  },
    printsticker(){
      let flierRegex = new RegExp("^RVP");

		 this.loginput = {
			CurrentHubID : this.hubId,
			FlyerCode : flierRegex.test(this.shipment.trim().toUpperCase()) ? this.shipment.trim() :this.shipmentData.fliercode ? this.shipmentData.fliercode : '',
			FlyerShippingId : this.shipmentData.shippingid ? this.shipmentData.shippingid:this.this.shipment.trim(),
			PrintedBy : this.username,
			PrintedDate : moment().format('YYYY-MM-DD HH:mm:ss'),
			Status : 'printFailed'
		 }
 		 this.input = {
 			 prnData: this.prnData,
 			 bagNumber: moment().format('DD-MM-YYYY')
 		 }

 		 this.isLoading = true;
 		 axios({
 				 method: "POST",
 				 url:  "http://localhost:4500/printer/printbagsticker",
 				 data: this.input,
 			 })
 			 .then(result => {
         console.log("result",result);
 				if (result.data.ResultCode == 100) {
          this.loginput.Status = 'printDone';
          this.addStickerLog(this.loginput);
 				  this.$alertify.success(result.data.ReturnMessage);
          if(this.shipmentData.shipmenttype.toLowerCase()=='dto'){
            // Start the spinner loader and set the loading message
            this.isRedirectLoading = true;

            // Delay of 2 seconds before redirecting
            // setTimeout(() => {
              // Perform the redirection
              this.$router.push('/InScanRVPShipments')
            // },2000);
            this.isRedirectLoading = false;
          }
 				  this.reset();
 				 } else {
           this.addStickerLog(this.loginput);
 					 this.$alertify.error(result.data.ReturnMessage);
           this.reset();
 				 }
 			 }, error => {
         console.log("Errro block",error);
 				 var code = error.response == undefined ? code = 0 : error.response.status;
 				 if (code == 500) {
 					 this.$alertify.error("Printer API error");
 					 console.log(error.response.statusText);
 				 } else if (error) {
 					 this.$alertify.error("Printer not connected")
 				 }
         this.addStickerLog(this.loginput);
 			 })
 			 this.isLoading = false;
    },
    barcodeevent(event){
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if (keycode == 13) {
        if(this.selected == '0'){
          this.showdata();
        }
        if(this.selected == '1') {
          this.showRTOLabel2();
        }
      }
    },
    addStickerLog(input) {
      console.log("in log");
      axios({
      method: "POST",
      url: apiUrl.api_url + 'external/RTO/sticker/add/log',
      data: input
    })
    .then(result => {
      if (result.data.code == 200) {
        this.$alertify.success('Log Created Successfully');
        this.reset();
      }else{
        this.$alertify.error(result.data.message);
      }
    }, error => {
      this.$alertify.error(error.message);
    })
	  },
     // Start Disable Manual Entry For Flyer Barcode
     handleDragOver(event) {
      event.preventDefault();
    },
    DelayExecution(f, delay) {
      var timer = null;
      return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = window.setTimeout(function () {
          f.apply(context, args);
        },
        this.ttl || 200);
      };
    },
    KeyHandle() {
      const vm = this;
      vm.keyFiredCount.value = 0;
      if ($("#shippingID").val() != '' && !vm.isKeyUpBound) {
        vm.isKeyUpBound = true;
        $("#shippingID").on("keyup", this.DelayExecution(function (event) {
          let keycode = (event.keyCode ? event.keyCode : event.which);
          vm.keyFiredCount.value = vm.keyFiredCount.value + 1;
          vm.oncallImediate(keycode);
        }));
      }

      if ($("#shipment").val() != '' && !vm.isKeyUpBound) {
        vm.isKeyUpBound = true;
        $("#shipment").on("keyup", this.DelayExecution(function (event) {
          let keycode = (event.keyCode ? event.keyCode : event.which);
          vm.keyFiredCount.value = vm.keyFiredCount.value + 1;
          vm.oncallImediate(keycode);
        }));
      }

    },
    oncallImediate(keycode) {
      let manualEntryDisableCriteria = this.flyerBarcodeList;
      if (this.selected == '0') {
        if ($("#shippingID").val() == '') {
          this.keyFiredCount.value = 0;
          return false;
        }
        else if (($("#shippingID").val() != '') && this.keyFiredCount.value <= 1 && keycode == 13) {
          console.log('Input given from scanner.!');
          this.showdata();
        }
        else {
          if (manualEntryDisableCriteria.some(prefix => $("#shippingID").val().trim().toUpperCase().startsWith(prefix)) && this.keyFiredCount.value <= 1 && keycode != 13) {
          this.$alertify.error('Please Enter/Scan AWB for RTO or Scan Flyer Barcode for DTO');
            if (this.shippingID) {
              this.shippingID = "";
            }
            return false;
          } else {
            console.log('User Input detection .!');
          }
        }
      }
      if (this.selected == '1') {

        if ($("#shipment").val() == '') {
          this.keyFiredCount.value = 0;
          return false;
        }
        else if ($("#shipment").val() != '' && this.keyFiredCount.value <= 1 && keycode == 13) {
          console.log('Input given from scanner.!');
          this.showRTOLabel2();
        }
        else {
          if (manualEntryDisableCriteria.some(prefix => $("#shipment").val().trim().toUpperCase().startsWith(prefix)) && this.keyFiredCount.value <= 1 && keycode != 13) {
            this.$alertify.error('Please Enter/Scan AWB for RTO or Scan Flyer Barcode for DTO');
            if (this.shipment) {
              this.shipment = '';
            }
            return false;
          } else {
            console.log('User Input detection .!');
          }
        }
      }
    },
    detectInputForStickerPrint(event) {
      let currentTime = Date.now();
      
      if (this.lastKeyTime === 0 || this.lastKeyTime === null || this.lastKeyTime === undefined) {
        this.lastKeyTime = currentTime;
        return;
      }
    
      let timeDiff = currentTime - this.lastKeyTime;
      this.lastKeyTime = currentTime;
    
      this.isScannerInput = timeDiff < this.threshold;

      clearTimeout(this.scanTimeout);
      this.scanTimeout = setTimeout(() => {
        if (this.isScannerInput && this.shippingID.length > 6) {
          this.callAPIForStickerPrint(this.shippingID);
        }
      }, this.ttl);
    },    
    handleInputForStickerPrint() {
      if (this.isScannerInput === false && this.shippingID.length > 3 && this.flyerBarcodeList.some(prefix => this.shippingID.toUpperCase().startsWith(prefix))) {
        this.$alertify.error('Please Enter/Scan AWB for RTO or Scan Flyer Barcode for DTO');
        this.shippingID = "";
        return;
      }
    },
    callAPIForStickerPrint(scannedValue) {
      console.log("Calling API with scanned data:", scannedValue);
      this.showdata();
    },
    detectInputForDTOPaperSheet(event) {
      let currentTime = Date.now();
      
      if (this.lastKeyTime === 0 || this.lastKeyTime === null || this.lastKeyTime === undefined) {
        this.lastKeyTime = currentTime;
        return;
      }
    
      let timeDiff = currentTime - this.lastKeyTime;
      this.lastKeyTime = currentTime;
    
      this.isScannerInput = timeDiff < this.threshold;

      clearTimeout(this.scanTimeout);
      this.scanTimeout = setTimeout(() => {
        if (this.isScannerInput && this.shipment.length > 6) {
          this.callAPIForDTOPaperSheet(this.shipment);
        }
      }, this.ttl);
    },    
    handleInputForDTOPaperSheet() {
      if (this.isScannerInput === false && this.shipment.length > 3 && this.flyerBarcodeList.some(prefix => this.shipment.toUpperCase().startsWith(prefix))) {
        this.$alertify.error('Please Enter/Scan AWB for RTO or Scan Flyer Barcode for DTO');
        this.shipment = "";
        return;
      }
    },
    callAPIForDTOPaperSheet(scannedValue) {
      console.log("Calling API with scanned data:", scannedValue);
      this.showRTOLabel2();
    },
    // End Disable Manual Entry For Flyer Barcode

    /* Get One Pager Configuration here */
    checkOnePagerEnabled() {
      let RequestForOnePagerFlag = {
        "hubId": this.hubId
      };
      getOnePagerEnabledFlag(RequestForOnePagerFlag, (result) => {
        try {
          if (result.data.code == 200) {
            if (result.data.data == true) {
              this.$router.push('/PrintLabelv2')
            }
          }
        } catch (error) {
          console.log('result------', error.message);
        }
      })
    },
  }
}

Validator.extend('santiseShippingID', {
  getMessage: field => 'Please enter valid flyerbarcode',
  validate: value => {
    let regexExpFlyerbarcode = /[!@#$%^&*`'[+~/(),.?":{}|<>]/ ;
    if(regexExpFlyerbarcode.test(value) == false){
      return true;
    } else {
      return false;
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/components/RVPPrintLabel/RVPPrintLabel.component.js